import { render, staticRenderFns } from "./ResultList.vue?vue&type=template&id=12fd3084&scoped=true&"
import script from "./ResultList.vue?vue&type=script&lang=ts&"
export * from "./ResultList.vue?vue&type=script&lang=ts&"
import style0 from "./ResultList.vue?vue&type=style&index=0&id=12fd3084&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fd3084",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VDivider,VSpacer})
